/**
 * This component represents a single search sidebar filter section (e.g. "Locations", "Venue", etc.)
 */
import * as React from 'react';
import cn from 'classnames';
import { isFunction } from '../../utils/functions';
import { Badge } from '@cvent/carina/components/Badge';
import { ChevronDownIcon, ChevronUpIcon } from '@cvent/carina/components/Icon';
const styles = require('./FiltersSection.scss');

interface FilterSectionProps {
    sectionTitle: string | React.ReactNode;
    badgeCount?: number;
    defaultExpanded: boolean;
    clearable?: boolean;
    clearCallback?: () => void;
    children?: ((props: { expanded: boolean }) => React.ReactNode) | React.ReactNode;
}

export const FilterSection: React.FC<FilterSectionProps> = (props) => {
    const [expanded, setExpanded] = React.useState(props.defaultExpanded); // Default expanded

    const clearFilters = (e: React.SyntheticEvent) => {
        !!props.clearCallback && props.clearCallback();
        e.stopPropagation();
    };

    return (
        <div className={styles.wrapper}>
            <div className={cn(styles.header, { [styles.headerCollapsed]: !expanded })} onClick={() => setExpanded(!expanded)}>
                <div className={styles.headerContent}>
                    <div className={styles.headerText}>{props.sectionTitle}</div>
                    {!!props.badgeCount && (
                        <span className={styles.badge}>
                            <Badge content={`${props.badgeCount}`} />
                        </span>
                    )}
                </div>
                <div className={styles.headerRight}>
                    {Boolean(props.clearable && props.badgeCount) && (
                        <button className={styles.clearLink} onClick={clearFilters}>
                            Clear
                        </button>
                    )}
                    {expanded ? <ChevronUpIcon size='s' color='#69717A' /> : <ChevronDownIcon size='s' color='#69717A' />}
                </div>
            </div>
            <div className={cn(styles.body, { [styles.bodyCollapsed]: !expanded })}>
                {props.children && (isFunction(props.children) ? props.children({ expanded }) : props.children)}
            </div>
        </div>
    );
};
